import { render, staticRenderFns } from "./ActiveBalance.vue?vue&type=template&id=58d0e826&scoped=true&"
import script from "./ActiveBalance.vue?vue&type=script&lang=js&"
export * from "./ActiveBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d0e826",
  null
  
)

export default component.exports